import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';

const fairnessTextKeys = [
  'FAIRNESS_P1',
  'FAIRNESS_P2',
  'FAIRNESS_P3',
  'FAIRNESS_P4',
  'FAIRNESS_P5',
  'FAIRNESS_P6',
  'FAIRNESS_P7',
  'FAIRNESS_P8',
  'FAIRNESS_P9',
  'FAIRNESS_P10',
  'FAIRNESS_P11',
  'FAIRNESS_P12',
  'FAIRNESS_P13',
  'FAIRNESS_P14',
  'FAIRNESS_P15',
  'FAIRNESS_P16',
];

export function AboutHash({ scrollRef }) {
  const burnedCardsIds = useIdsGenerator(fairnessTextKeys);
  const t = useTranslation();

  return (
    <div className='blackjack-modal-par-holder' ref={scrollRef || null}>
      {fairnessTextKeys.map((item, index) => (
        <p key={burnedCardsIds[index]} className='blackjack-modal-par'>
          {t(item)}
        </p>
      ))}
    </div>
  );
}
